<template>
  <div>
    <h1>Worldguard</h1>
    <h2>kesken!</h2>
    <p>Jafarinin käsialaa</p>
    <p>Karanteenissa aluesuojaus suoritetaan käytännössä Worldguard -pluginilla</p>
    <a
      href="https://worldguard.enginehub.org/en/latest/"
    >Worldguardin oma englanninkielinen dokumentaatio</a>

   
    <Command command="rg" params="define [-n] [-g] &lt;id> &lt;owner1&gt; [&lt;owner2&gt;] [... &lt;ownerN&gt;]" desc example />
<Command command="rg" params="create (...)" desc example />
<Command command="rg" params="d (...)" desc example />

    <p>
      <strong>Ylläpito suojaa pelaajien pyynnöstä heille alueita.</strong>
      Suojatessa on huomioitava seuraavat asiat. 🠶 Hyvä tapa nähdä onko 100 ruudun sisällä ollut toimintaa on
      antaa seuraava komento:
    </p>
    <Command command="co" params="lookup action:click time:30 radius:100" desc example />
    <p>
      Kyseinen komento listaa kaikki klikkaukset 100 ruudun sisältä ja listausta voi selata komennolla 
         <Command command="co" params="lookup &lt;ivunro&gt; tai /co l &lt;sivu&gt;" desc=" Koska stone on yleisin materiaali voi listausta lyhentää lisäämällä
      hakuun b:Stone ja muuttamalla action:-block. Näin vain stone blockin rikkomiset näkyvät listauksessa." example="/co lookup b:stone action:-block" />

      
    </p>
    <p>
      Kyseisellä listauksella pystyy osin varmistamaan ettei vahingossa suojaa toisen pelaajan rakennelmia
      toiselle pelaajalle. Gamemode 3 on hyvä tapa tarkistaa ettei maan alla ole rakennelmia, mikäli aiempi
      klikkaukset listaava komento näyttää muiden pelaajien tapahtumia.
      <i>
        Suojaus ei ole kiireellinen, koska servulla grieffaus on kielletty ja ylläpito pystyy palauttamaan
        grieffauksen edeltävän tilanteen.
      </i>
      Rollauksesta lisää Coreprotection kappaleessa. Näin ollen pelaaja voi aloittaa rakentamisen jolloin saadaan
      kuva tarvittavan suojaus alueen koosta. Mikäli ylläpitäjä on epävarma suojauksen koosta tai muista
      seikoista, voi tehtävän antaa ylemmän ylläpidon tehtäväksi, vaikka luomalla #apua kanavalla tiketin.
    </p>

    <p>
      🠶 Mikäli yksittäiselle pelaajalle luodaan alue se nimetään käyttäen pelaajan nimeä ja lisäämällä perään
      juokseva numerointi esim jafarin_1, jafarin_2, jafarin_3
    </p>
    <p>🠶 Useamman omistajan alueelle, kuten kylälle, kysytään suojaukselle nimi ja käytetään sitä.</p>
    <p>🠶 Erikoismerkkejä ja skandeja ei nimessä voi käyttää. Isot kirjaimet muutetaan automaattisesti pieneksi.</p>
    <h2>Suojauksen luominen</h2>
    <ol>
      <li>Vastakkaisten nurkkien osoittaminen puukirveellä tai //pos1 ja //pos2 komennoilla.</li>
      <li>
        Tarvittaessa alueen laajentaminen koskemaan pystysuunnassa koko matkaa bedrockista taivaaseen //expand
        vert
      </li>
      <li>
        Suojaus luodaan komennolla
        <Command command="rg" params="define &lt;alueen_nimi&gt; &lt;omistaja1&gt; &lt;omistaja2&gt; &lt;omistaja3&gt;" desc example />
      </li>
      <li>Tarkista komennolla /alue, että kyseinen alue on syntynyt oikealla tavalla ja omistajat ovat paikallaan.</li>
    </ol>

    <p>
      🠶 Omistajat pystyvät itse lisäämään ja poistamaan asukkaita alueeltaan komennolla /trust &lt;alueen_nimi>
      &lt;pelaaja>. Tietoa alueestaan he saavat antamalla komennon /alue
    </p>
    <h2>Alueen laajentaminen ja poistaminen</h2>
     <Command command="rg" params="redefine [-g]" desc example />
     <Command command="rg" params="rg move (...)" desc example />
     <Command command="rg" params="rg remove [-w &lt;world&gt;] [-f] [-u] &lt;id&gt;" desc example />
     <Command command="rg" params="rg rem (...)" desc example />
     <Command command="rg" params="rg delete (...)" desc example />
     <Command command="rg" params="rg del (...)" desc example />
     <Command command="rg" params="redefine [-g]" desc example />

    <h2>Omistajan lisääminen ja poistaminen</h2>
    <p>
      Jälkikäteen omistajia voi lisätä addowner ja poistaa removeowner valinnoilla: /rg
      <Command
        command="rg"
        params="addowner [-w
            &lt;world&gt;] [-n] &lt;id&gt; &lt;owners...&gt;"
        desc
        example
      />
    </p>
    <p>
      <Command command="rg" params="ao (...)" desc example />
    </p>

    <p>
      <Command
        command="rg"
        params="removeowner [-w &lt;world&gt;] [-n] [-a] &lt;id&gt; &lt;owners...&gt;"
        desc
        example
      />
      <Command command="rg" params="ro (...)" desc example />
    </p>

    <h2>Asukkaiden lisääminen ja poistaminen</h2>
    <p>
      Asukkaiden hallinta kuuluu pääasiassa alueen omistajille, mutta ylläpito voi tarvittaessa suorittaa kyseisen
      toimen. Poistaminen tapahtuu käyttämällä removemember valintoa ja lisääminen addmember seuraavan ohjeen
      mukaisesti.
    </p>


     <Command command="rg" params="addmember [-w &lt;world&gt;] [-n] &lt;id&gt; &lt;members...&gt;" desc example />
     <Command command="rg" params="am (...)" desc example />

        <Command command="rg" params="removemember [-w &lt;world>] [-n] [-a] &lt;id> &lt;members...>" desc example />

  </div>
</template>

<script>
import Command from "@/components/Command";

export default {
  name: "aluesuojaus",
  components: {
    Command
  },
  metaInfo: {
    title: "Aluesuojaus"
  }
};
</script>

<style scoped></style>
